import styled from 'styled-components'

export const StyledFooterContainer = styled.footer`
  padding: 74px 0 32px;
  text-align: center;
  background: #F3F6F8;
  color: #848484;
  font-size: 12px;
`